/**
 * useComecarPlano — lo que hace cada «Começar o meu plano» de la landing.
 *
 *   - Con el enlace del correo (`token`) primero abre la sesión
 *     (`POST /public/oferta-pt/<token>/entrar/`): pagar exige sesión, y es AQUÍ
 *     —con un clic, nunca al cargar— donde se abre, porque los escáneres de
 *     correo cargan los enlaces. La sesión y el `csrftoken` nuevos llegan como
 *     cookies y `httpClient` los lee en la petición siguiente.
 *   - Después pide el checkout (`POST /billing/oferta-pt/checkout`) con el id
 *     del botón pulsado, y salta a Stripe.
 *
 * `cargando` es el id del botón en curso: solo ese pinta el spinner, pero todos
 * se desactivan para que un doble clic no abra dos sesiones de Stripe.
 */
import { useState } from 'react';
import toast from 'react-hot-toast';

import { criarCheckoutOferta, entrarOfertaPt } from '@/api/ofertaPtService';

const ERRORES = {
  oferta_cerrada: 'O Plano Google Maps 7 Dias já terminou.',
  sem_vagas: 'Já não há vagas disponíveis.',
  no_elegible: 'Esta oferta não está disponível para a tua conta.',
  locais_invalidos: 'Escolhe entre 1 e 30 locais.',
  caducado: 'Este link expirou. Entra na tua conta para continuar.',
  no_permitido: 'Não conseguimos abrir a tua conta a partir deste link. Entra com o teu email e palavra-passe.',
  csrf: 'Não conseguimos abrir a tua conta a partir deste link. Recarrega a página ou entra com o teu email e palavra-passe.',
};

export default function useComecarPlano(token) {
  const [cargando, setCargando] = useState(null);

  // `locais`: los del selector de la landing con ficha. Sin él, el servidor
  // pone uno por local activo.
  const comecar = async (ctaId, locais) => {
    if (cargando) return;
    setCargando(ctaId);
    try {
      if (token) await entrarOfertaPt(token);
      const url = await criarCheckoutOferta(locais ? { ctaId, locais } : { ctaId });
      window.location.assign(url);
    } catch (e) {
      const code = e?.response?.data?.code;
      toast.error(ERRORES[code] || 'Não foi possível abrir o pagamento. Tenta de novo ou fala com o Afaq.');
      setCargando(null);
    }
  };

  return { comecar, cargando };
}
